/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Accountid1Inputs */

const en_entity_accountid1 = /** @type {(inputs: Entity_Accountid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account ID`)
};

const de_entity_accountid1 = /** @type {(inputs: Entity_Accountid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto-ID`)
};

/**
* | output |
* | --- |
* | "Account ID" |
*
* @param {Entity_Accountid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_accountid1 = /** @type {((inputs?: Entity_Accountid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Accountid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_accountid1(inputs)
	return de_entity_accountid1(inputs)
});
export { entity_accountid1 as "entity_accountId" }